/**
 * 宿舍大屏时间格式化（对照源码 util/tool.js）。创建于 2026-10-17
 */
export function formateDate(fmt = 'YYYY-mm-dd', date = '') {
	if (!date) return ''

	try {
		if (typeof date === 'string') {
			let trimmed = date.trim()
			if (/^\d{1,2}:\d{1,2}(:\d{1,2})?$/.test(trimmed)) {
				if (fmt === 'HH:MM:SS' || fmt === 'HH:MM') {
					const parts = trimmed.split(':')
					const h = parts[0].padStart(2, '0')
					const m = (parts[1] || '00').padStart(2, '0')
					const s = (parts[2] || '00').padStart(2, '0')
					return fmt === 'HH:MM' ? `${h}:${m}` : `${h}:${m}:${s}`
				}
				trimmed = '2000/01/01 ' + trimmed
			}
			trimmed = trimmed.replace(/-/g, '/').replace(/T/g, ' ')
			if (trimmed.indexOf('/') === -1 && !isNaN(Number(trimmed))) {
				date = new Date(parseFloat(trimmed))
			} else {
				date = new Date(trimmed)
			}
		} else if (typeof date === 'number') {
			date = new Date(date)
		}
	} catch (e) {
		return ''
	}

	if (isNaN(date.getTime())) {
		return typeof date === 'string' ? date : ''
	}

	const weekArr = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
	const weekArr2 = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
	// 星期先按字面量替换（避免 W+ 被当成「多个 W」）；年月日仍用 Y+/m+/d+ 量词匹配 YYYY/mm/dd
	let result = String(fmt)
		.replace(/W\+/g, weekArr[date.getDay()])
		.replace(/w\+/g, weekArr2[date.getDay()])
	const opt = {
		'Y+': date.getFullYear().toString(),
		'm+': (date.getMonth() + 1).toString(),
		'd+': date.getDate().toString(),
		'H+': date.getHours().toString(),
		'M+': date.getMinutes().toString(),
		'S+': date.getSeconds().toString(),
	}
	Object.keys(opt).forEach((k) => {
		const ret = new RegExp('(' + k + ')').exec(result)
		if (ret) {
			result = result.replace(
				ret[1],
				ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
			)
		}
	})
	return result
}

export function todayStr() {
	return formateDate('YYYY-mm-dd', new Date())
}

/**
 * 深度冻结只读大屏数据，避免 Vue 对整棵宿舍树做响应式劫持（TV 长时间运行省内存）。
 * 创建于 2026-10-17
 */
export function deepFreeze(value) {
	if (!value || typeof value !== 'object' || Object.isFrozen(value)) return value
	Object.freeze(value)
	const keys = Object.getOwnPropertyNames(value)
	for (let i = 0; i < keys.length; i++) {
		deepFreeze(value[keys[i]])
	}
	return value
}
